import {
    TextField,
    MenuItem,
    Select,
    FormControl,
    InputLabel,
    Box,
    Checkbox,
    TableCell,
    TableRow,
    TableHead,
    Table,
    TableContainer,
    Paper,
    TableBody,
    Button,
    Grid,
    CircularProgress,
    Tooltip,
    Backdrop,
    InputAdornment,
    IconButton,
    Chip,
    Stack,
    Pagination
} from "@mui/material";
import DatePicker from "react-datepicker";
import React, {useEffect, useState} from "react";
import axios from "axios";
import {ka} from "date-fns/locale";
import "./CertificateFilesFetcher.css";
import {AiOutlineClear, AiOutlineFile, AiOutlineSearch} from "react-icons/ai";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSearch} from "@fortawesome/free-solid-svg-icons";
import CustomAlert from "../../components/ConfirmationModal/CustomAlert";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import {MdClose} from "react-icons/md";
import {FaFileAlt, FaFileArchive, FaSearch} from "react-icons/fa";

function formatDate(dateString) {

    if (dateString === null) {
        return ""
    }

    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
}

const CertificateFilesFetcher = ({geoIds}) => {
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [fileTypeFilter, setFileTypeFilter] = useState('allFiles');
    const optionsForFileTypeFilter = [
        {value: 'allFiles', label: 'ყველა დოკუმენტი'},
        {value: 'IsInspectFile', label: 'ინსპექტირების ოქმები'},
        {value: 'IsSertificatFile', label: 'ინსპექტერების სერტიფიკატები'},
        {value: 'InpectOrderAttachment', label: 'სამართალდარღვევის ოქმები'},
    ];
    const [formData, setFormData] = useState({
        sertificatReleaseDateFrom: null,
        sertificatReleaseDateTo: null,
        InspectionDocumentmplementationDateFrom: null,
        InspectionDocumentmplementationDateTo: null,
        InspectionDocumentCheckingDateFrom: null,
        InspectionDocumentCheckingDateTo: null,
        InspectionSertificatValidityPeriodDateFrom: null,
        InspectionSertificatValidityPeriodDateTo: null,
        PertmiTypeIdList: '',
        RegionName: '',
        IsSertificatFile: null,
        IsInspectFile: null,
        InpectOrderAttachment: null,
        InpectOrderAttachmentDateTo: null,
        InpectOrderAttachmentDateFrom: null,
        CasefileNumber: ''

    });
    const [filesList, setFilesList] = useState([]);
    const [totalCount, setTotalCount] = useState(0);
    const [documentIds, setDocuemntIds] = useState([]);
    const [permitTypes, setPermitTypes] = useState([]);
    const [regions, setRegions] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [showAlert, setShowAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    const [alertType, setAlertType] = useState('');
    const [isDownloading, setIsDownloading] = useState(false);
    const [resetFilters, setResetFilters] = useState(false);
    const delay = ms => new Promise(res => setTimeout(res, ms));
    const hasActiveFilters = (filters) => {
        return Object.values(filters).some(value => value !== null && value !== '');
    };
    const namesInGeorgian = {
        "sertificatReleaseDateFrom": "ინსპექტირების სერტიფიკატის გაცემის თარიღიდან",
        "sertificatReleaseDateTo": "ინსპექტირების სერტიფიკატის გაცემის თარიღამდე",
        "InspectionSertificatValidityPeriodDateFrom": "ინსპექტირების სერტიფიკატის მოქმედების ვადიდან",
        "InspectionSertificatValidityPeriodDateTo": "ინსპექტირების სერტიფიკატის მოქმედების ვადამდე",
        "InspectionDocumentmplementationDateFrom": "ინსპექტირების ოქმის განხორციელების თარიღიდან",
        "InspectionDocumentmplementationDateTo": "ინსპექტირების ოქმის განხორციელების თარიღამდე",
        "InspectionDocumentCheckingDateFrom": "ინსპექტირების ოქმის გადამოწმების თარიღამდე",
        "InspectionDocumentCheckingDateTo": "ინსპექტირების ოქმის გადამოწმების თარიღამდე",
        "InpectOrderAttachmentDateFrom": "სამართალდარღვევის ოქმის შედგენის თარიღიდან",
        "InpectOrderAttachmentDateTo": "სამართალდარღვევის ოქმის შედგენის თარიღამდე",
        "PertmiTypeIdList": "ობიექტი",
        "RegionName": "რეგიონი",
        "CasefileNumber": "დოკუმენტის ნომერი",


    }

    useEffect(() => {
        if (fileTypeFilter === 'IsInspectFile') {
            setFormData({
                ...formData,
                sertificatReleaseDateFrom: null,
                sertificatReleaseDateTo: null,
                InspectionSertificatValidityPeriodDateFrom: null,
                InspectionSertificatValidityPeriodDateTo: null,
                InpectOrderAttachmentDateFrom: null,
                InpectOrderAttachmentDateTo: null,
            });
        } else if (fileTypeFilter === 'IsSertificatFile') {
            setFormData({
                ...formData,
                InspectionDocumentmplementationDateFrom: null,
                InspectionDocumentmplementationDateTo: null,
                InspectionDocumentCheckingDateFrom: null,
                InspectionDocumentCheckingDateTo: null,
                InpectOrderAttachmentDateFrom: null,
                InpectOrderAttachmentDateTo: null,
            });
        } else if (fileTypeFilter === 'InpectOrderAttachment') {
            setFormData({
                ...formData,
                InspectionDocumentmplementationDateFrom: null,
                InspectionDocumentmplementationDateTo: null,
                InspectionDocumentCheckingDateFrom: null,
                InspectionDocumentCheckingDateTo: null,
                sertificatReleaseDateFrom: null,
                sertificatReleaseDateTo: null,
                InspectionSertificatValidityPeriodDateFrom: null,
                InspectionSertificatValidityPeriodDateTo: null,
            });
        }
    }, [fileTypeFilter]);

    const handleSelect = (id) => {
        const currentIndex = selectedFiles.indexOf(id);
        const newSelectedFiles = [...selectedFiles];

        if (currentIndex === -1) {
            newSelectedFiles.push(id);
        } else {
            newSelectedFiles.splice(currentIndex, 1);
        }

        setSelectedFiles(newSelectedFiles);
    };


    const findObjectNameById = (objectId) => {
        const object = permitTypes.find(child => child.id === objectId)
        return object ? object.title : ""
    };

    const handleSelectAll = (event) => {
        if (event.target.checked) {
            setSelectedFiles(documentIds);
            return;
        }
        setSelectedFiles([]);
    };

    const isSelected = (id) => selectedFiles.includes(id);


    useEffect(() => {
        void fetchFiles();
    }, [page, pageSize]);

    useEffect(() => {
        const fetchRegions = async () => {
            try {
                const {data} = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/DictionaryTypesDetalisById?CategoryId=${geoIds.regionId}`);
                setRegions(data.data.resultlist || []);
            } catch (error) {
                console.error('Error fetching regions:', error);
            }
        };
        void fetchRegions();

    }, [geoIds.regionId]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/GetPermitTypeTree`);
                const data = response.data.data;

                const findLastChildren = (nodes) => {
                    let children = [];
                    nodes.forEach(node => {
                        if (node.childrenPermitTypes && node.childrenPermitTypes.length > 0) {
                            children = [...children, ...findLastChildren(node.childrenPermitTypes)];
                        } else {
                            children.push(node);
                        }
                    });
                    return children;
                };

                const lastNode = data[data.length - 1];
                const lastNodeChildren = findLastChildren([lastNode]);
                setPermitTypes(lastNodeChildren);
            } catch (error) {
            }
        };

        void fetchData();
    }, []);


    const fetchFiles = async () => {
        setLoading(true);
        const params = new URLSearchParams({
            ...formData,
            IsSertificatFile: fileTypeFilter === 'IsSertificatFile' ? true : null,
            IsInspectFile: fileTypeFilter === 'IsInspectFile' ? true : null,
            InpectOrderAttachment: fileTypeFilter === 'InpectOrderAttachment' ? true : null,
            sertificatReleaseDateFrom: formData.sertificatReleaseDateFrom ? formData.sertificatReleaseDateFrom.toISOString() : (formData.sertificatReleaseDateTo ? new Date('1970-01-01').toISOString() : null),
            sertificatReleaseDateTo: formData.sertificatReleaseDateTo ? formData.sertificatReleaseDateTo.toISOString() : (formData.sertificatReleaseDateFrom ? new Date('2100-01-01').toISOString() : null),
            InspectionDocumentmplementationDateFrom: formData.InspectionDocumentmplementationDateFrom ? formData.InspectionDocumentmplementationDateFrom.toISOString() : (formData.InspectionDocumentmplementationDateTo ? new Date('1970-01-01').toISOString() : null),
            InpectOrderAttachmentDateFrom: formData.InpectOrderAttachmentDateFrom ? formData.InpectOrderAttachmentDateFrom.toISOString() : (formData.InpectOrderAttachmentDateTo ? new Date('1970-01-01').toISOString() : null),
            InpectOrderAttachmentDateTo: formData.InpectOrderAttachmentDateTo ? formData.InpectOrderAttachmentDateTo.toISOString() : (formData.InpectOrderAttachmentDateFrom ? new Date('2100-01-01').toISOString() : null),
            InspectionDocumentmplementationDateTo: formData.InspectionDocumentmplementationDateTo ? formData.InspectionDocumentmplementationDateTo.toISOString() : (formData.InspectionDocumentmplementationDateFrom ? new Date('2100-01-01').toISOString() : null),
            InspectionDocumentCheckingDateTo: formData.InspectionDocumentCheckingDateTo ? formData.InspectionDocumentCheckingDateTo.toISOString() : (formData.InspectionDocumentCheckingDateFrom ? new Date('2100-01-01').toISOString() : null),
            InspectionDocumentCheckingDateFrom: formData.InspectionDocumentCheckingDateFrom ? formData.InspectionDocumentCheckingDateFrom.toISOString() : (formData.InspectionDocumentCheckingDateTo ? new Date('1970-01-01').toISOString() : null),
            InspectionSertificatValidityPeriodDateTo: formData.InspectionSertificatValidityPeriodDateTo ? formData.InspectionSertificatValidityPeriodDateTo.toISOString() : (formData.InspectionSertificatValidityPeriodDateFrom ? new Date('2100-01-01').toISOString() : null),
            InspectionSertificatValidityPeriodDateFrom: formData.InspectionSertificatValidityPeriodDateFrom ? formData.InspectionSertificatValidityPeriodDateFrom.toISOString() : (formData.InspectionSertificatValidityPeriodDateTo ? new Date('1970-01-01').toISOString() : null),
        });

        try {
            const fetchPromise = axios.get(`${process.env.REACT_APP_API_BASE_URL}/GetFiltredSertificatAndInspectDocument?${params}&page=${page - 1}&pageSize=${pageSize}`);
            const [response] = await Promise.all([fetchPromise, delay(1500)]);
            const {data} = response;
            if (data.success === true) {
                setFilesList(data.data.resultItems !== null ? data.data.resultItems : []);
                setTotalCount(data.data.totalCount !== null ? data.data.totalCount : 0);
                setDocuemntIds(data.data.getFullCaseFileIds !== null ? data.data.getFullCaseFileIds : []);
                setShowAlert(false);
                setAlertMessage('');
                setAlertType('');
            } else {
                setFilesList([]);
                setShowAlert(true);
                setAlertMessage('დაფიქსირდა შეცდომა, ცადეთ მოგვიანებით!');
                setAlertType('error');
            }
        } catch (error) {
            console.error('Fetching data failed:', error);
            setShowAlert(true);
            setAlertMessage('დაფიქსირდა შეცდომა, ცადეთ მოგვიანებით!');
            setAlertType('error');
        } finally {
            setLoading(false);
        }
    };


    const clearForm = () => {
        setFormData({
            sertificatReleaseDateFrom: null,
            sertificatReleaseDateTo: null,
            InspectionDocumentmplementationDateFrom: null,
            InspectionDocumentmplementationDateTo: null,
            InpectOrderAttachmentDateTo: null,
            InpectOrderAttachmentDateFrom: null,
            InspectionDocumentCheckingDateFrom: null,
            InspectionDocumentCheckingDateTo: null,
            InspectionSertificatValidityPeriodDateFrom: null,
            InspectionSertificatValidityPeriodDateTo: null,
            PertmiTypeIdList: '',
            RegionName: '',
            CasefileNumber: '',
            IsSertificatFile: null,
            IsInspectFile: null,
            InpectOrderAttachment: null,
        });
        setFileTypeFilter('allFiles')
        setResetFilters(true)
    };

    useEffect(() => {
        if (resetFilters) {
            void fetchFiles();
            setResetFilters(false);
        }
    }, [resetFilters]);

    const FilterChips = ({filters, onDelete}) => {
        return (
            <Box sx={{display: 'flex', flexWrap: 'wrap', gap: 1}}>
                {Object.keys(filters).map((key) => filters[key] && (
                    <>
                        {key === "PertmiTypeIdList" ? (
                                <Chip
                                    key={key}
                                    label={`${namesInGeorgian[key]}: ${findObjectNameById(filters[key])}`}
                                    onDelete={() => onDelete(key)}
                                    color="primary"
                                />
                            )
                            : key === "RegionName" ?
                                (
                                    <Chip
                                        key={key}
                                        label={`${namesInGeorgian[key]}: ${filters[key]}`}
                                        onDelete={() => onDelete(key)}
                                        color="primary"
                                    />
                                )
                                : key === "CasefileNumber" ?
                                (
                                    <Chip
                                        key={key}
                                        label={`${namesInGeorgian[key]}: ${filters[key]}`}
                                        onDelete={() => onDelete(key)}
                                        color="primary"
                                    />
                                )
                                : key === "sertificatReleaseDateFrom" ?
                                    (
                                        <Chip
                                            key={key}
                                            label={`${namesInGeorgian[key]}: ${formatDate(filters[key])}`}
                                            onDelete={() => onDelete(key)}
                                            color="primary"
                                        />
                                    ) :
                                    key === "sertificatReleaseDateTo" ?
                                        (
                                            <Chip
                                                key={key}
                                                label={`${namesInGeorgian[key]}: ${formatDate(filters[key])}`}
                                                onDelete={() => onDelete(key)}
                                                color="primary"
                                            />
                                        ) :
                                        key === "InspectionDocumentmplementationDateFrom" ?
                                            (
                                                <Chip
                                                    key={key}
                                                    label={`${namesInGeorgian[key]}: ${formatDate(filters[key])}`}
                                                    onDelete={() => onDelete(key)}
                                                    color="primary"
                                                />
                                            ) : key === "InpectOrderAttachmentDateFrom" ?
                                                (
                                                    <Chip
                                                        key={key}
                                                        label={`${namesInGeorgian[key]}: ${formatDate(filters[key])}`}
                                                        onDelete={() => onDelete(key)}
                                                        color="primary"
                                                    />
                                                ) : key === "InpectOrderAttachmentDateTo" ?
                                                    (
                                                        <Chip
                                                            key={key}
                                                            label={`${namesInGeorgian[key]}: ${formatDate(filters[key])}`}
                                                            onDelete={() => onDelete(key)}
                                                            color="primary"
                                                        />
                                                    ) :
                                                    key === "InspectionDocumentmplementationDateTo" ?
                                                        (
                                                            <Chip
                                                                key={key}
                                                                label={`${namesInGeorgian[key]}: ${formatDate(filters[key])}`}
                                                                onDelete={() => onDelete(key)}
                                                                color="primary"
                                                            />
                                                        ) :
                                                        key === "InspectionDocumentCheckingDateFrom" ?
                                                            (
                                                                <Chip
                                                                    key={key}
                                                                    label={`${namesInGeorgian[key]}: ${formatDate(filters[key])}`}
                                                                    onDelete={() => onDelete(key)}
                                                                    color="primary"
                                                                />
                                                            ) :
                                                            key === "InspectionDocumentCheckingDateTo" ?
                                                                (
                                                                    <Chip
                                                                        key={key}
                                                                        label={`${namesInGeorgian[key]}: ${formatDate(filters[key])}`}
                                                                        onDelete={() => onDelete(key)}
                                                                        color="primary"
                                                                    />
                                                                ) :
                                                                key === "InspectionSertificatValidityPeriodDateFrom" ?
                                                                    (
                                                                        <Chip
                                                                            key={key}
                                                                            label={`${namesInGeorgian[key]}: ${formatDate(filters[key])}`}
                                                                            onDelete={() => onDelete(key)}
                                                                            color="primary"
                                                                        />
                                                                    ) :
                                                                    key === "InspectionSertificatValidityPeriodDateTo" ?
                                                                        (
                                                                            <Chip
                                                                                key={key}
                                                                                label={`${namesInGeorgian[key]}: ${formatDate(filters[key])}`}
                                                                                onDelete={() => onDelete(key)}
                                                                                color="primary"
                                                                            />
                                                                        ) :
                                                                        key === "sertificatReleaseDateTo" ?
                                                                            (
                                                                                <Chip
                                                                                    key={key}
                                                                                    label={`${namesInGeorgian[key]}: ${formatDate(filters[key])}`}
                                                                                    onDelete={() => onDelete(key)}
                                                                                    color="primary"
                                                                                />
                                                                            ) :
                                                                            (
                                                                                <div></div>
                                                                            )
                        }
                    </>
                ))}
            </Box>
        );
    };

    const handleDeleteFilter = (filterKey) => {


        setFormData(prev => ({...prev, [filterKey]: null}));
        setResetFilters(true);
    };

    const handleChange = (name, value) => {
        setFormData(prevState => ({...prevState, [name]: value}));
        if (value === '') {
            handleDeleteFilter(name);
        }
    };


    const handleDownload = async () => {
        setIsDownloading(true);
        const payload = {
            casefileIds: selectedFiles
        };

        try {
            const fetchPromise = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/CaseFilesDocumentsDownloadZip`, payload, {
                responseType: 'blob',
            });

            const [response] = await Promise.all([fetchPromise, delay(1500)]);

            const file = new Blob([response.data], {
                type: 'application/zip'
            });

            const fileURL = URL.createObjectURL(file);

            const fileLink = document.createElement('a');
            fileLink.href = fileURL;
            fileLink.setAttribute('download', "უწყებრივი რეესტრის დოკუმენტები");
            document.body.appendChild(fileLink);

            fileLink.click();

            fileLink.parentNode.removeChild(fileLink);
        } catch (error) {
        } finally {
            setIsDownloading(false);
        }
    };

    return (
        <div style={isDownloading ? {cursor: 'wait'} : {}} className={"certificate-files-fetcher-wrapper"}>
            <Box>
                <Backdrop open={isDownloading}
                          style={{zIndex: 1000, color: '#fff', backgroundColor: 'rgba(0, 0, 0, 0.9)'}}
                >
                    <div style={{textAlign: 'center', alignItems: 'center', justifyContent: 'center'}}>
                        <FaFileArchive style={{fontSize: 80, color: '#fff'}} className={"pulse-element"}/>
                        <h1>გთხოვთ დაელოდოთ...</h1>
                        <p>არქივი გენერირდება!</p>
                    </div>
                </Backdrop>
                <div>

                    <div className={"certificate-files-input-container"}>
                        <Grid item xs={12} sm={6} md={4}>
                            <FormControl fullWidth>
                                <InputLabel id="region-label">დოკუმენტის ტიპი</InputLabel>
                                <Select
                                    variant={"outlined"}
                                    labelId="doctype-label"
                                    className={"slide-in-input"}
                                    value={fileTypeFilter}
                                    label="დოკუმენტის ტიპი"
                                    onChange={(e) => setFileTypeFilter(e.target.value)}
                                >
                                    {optionsForFileTypeFilter.map((option) => (
                                        <MenuItem key={option.value}
                                                  value={option.value}>{option.label}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid>
                            <TextField
                                label="დოკუმენტის ნომერი"
                                variant="outlined"
                                type="text"
                                fullWidth
                                value={formData.CasefileNumber}
                                onChange={(e) => handleChange('CasefileNumber', e.target.value)}
                            />
                        </Grid>
                        {(fileTypeFilter !== 'IsSertificatFile' && fileTypeFilter !== 'InpectOrderAttachment') && (<>
                            <Grid item xs={12} sm={6} md={4}>
                                <DatePicker
                                    selected={formData.sertificatReleaseDateFrom}
                                    onChange={(newValue) => handleChange('sertificatReleaseDateFrom', newValue)}
                                    customInput={<TextField className={"slide-in-input"}
                                                            label="ინსპექტირების სერტიფიკატის გაცემის თარიღიდან"
                                                            variant="outlined" InputProps={{
                                        endAdornment: formData.sertificatReleaseDateFrom !== null ? (
                                            <InputAdornment position="end">
                                                <IconButton
                                                    onClick={() => {
                                                        handleChange('sertificatReleaseDateFrom', null)
                                                    }}
                                                    edge="end"
                                                >
                                                    <MdClose/>
                                                </IconButton>
                                            </InputAdornment>
                                        ) : null,
                                    }}/>}
                                    disabled={formData.InspectionDocumentmplementationDateFrom !== null
                                        || formData.InspectionDocumentmplementationDateTo !== null
                                        || formData.InspectionDocumentCheckingDateFrom !== null
                                        || formData.InspectionDocumentCheckingDateTo !== null
                                        || formData.InpectOrderAttachmentDateFrom !== null
                                        || formData.InpectOrderAttachmentDateTo !== null
                                    }
                                    autoComplete="off"
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                    className="certificate-files-datepicker-search"
                                    scrollableYearDropdown
                                    dateFormat="dd/MM/yyyy"
                                    locale={ka}
                                    popperProps={{
                                        positionFixed: true
                                    }}

                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                                <DatePicker
                                    selected={formData.sertificatReleaseDateTo}
                                    onChange={(newValue) => handleChange('sertificatReleaseDateTo', newValue)}
                                    customInput={<TextField className={"slide-in-input"}
                                                            label="ინსპექტირების სერტიფიკატის გაცემის თარიღამდე"
                                                            variant="outlined" InputProps={{
                                        endAdornment: formData.sertificatReleaseDateTo !== null ? (
                                            <InputAdornment position="end">
                                                <IconButton
                                                    onClick={() => {
                                                        handleChange('sertificatReleaseDateTo', null)
                                                    }}
                                                    edge="end"
                                                >
                                                    <MdClose/>
                                                </IconButton>
                                            </InputAdornment>
                                        ) : null,
                                    }}/>}
                                    autoComplete="off"
                                    showMonthDropdown
                                    disabled={formData.InspectionDocumentmplementationDateFrom !== null
                                        || formData.InspectionDocumentmplementationDateTo !== null
                                        || formData.InspectionDocumentCheckingDateFrom !== null
                                        || formData.InspectionDocumentCheckingDateTo !== null
                                        || formData.InpectOrderAttachmentDateFrom !== null
                                        || formData.InpectOrderAttachmentDateTo !== null
                                    }
                                    showYearDropdown
                                    dropdownMode="select"
                                    className="certificate-files-datepicker-search"
                                    scrollableYearDropdown
                                    dateFormat="dd/MM/yyyy"
                                    locale={ka}
                                    popperProps={{
                                        positionFixed: true
                                    }}

                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                                <DatePicker
                                    selected={formData.InspectionSertificatValidityPeriodDateFrom}
                                    onChange={(newValue) => handleChange('InspectionSertificatValidityPeriodDateFrom', newValue)}
                                    customInput={<TextField className={"slide-in-input"}
                                                            label="ინსპექტირების სერტიფიკატის მოქმედების ვადიდან"
                                                            variant="outlined"
                                                            InputProps={{
                                                                endAdornment: formData.InspectionSertificatValidityPeriodDateFrom !== null ? (
                                                                    <InputAdornment position="end">
                                                                        <IconButton
                                                                            onClick={() => {
                                                                                handleChange('InspectionSertificatValidityPeriodDateFrom', null)
                                                                            }}
                                                                            edge="end"
                                                                        >
                                                                            <MdClose/>
                                                                        </IconButton>
                                                                    </InputAdornment>
                                                                ) : null,
                                                            }}/>}
                                    autoComplete="off"
                                    showMonthDropdown
                                    disabled={formData.InspectionDocumentmplementationDateFrom !== null
                                        || formData.InspectionDocumentmplementationDateTo !== null
                                        || formData.InspectionDocumentCheckingDateFrom !== null
                                        || formData.InspectionDocumentCheckingDateTo !== null
                                        || formData.InpectOrderAttachmentDateFrom !== null
                                        || formData.InpectOrderAttachmentDateTo !== null
                                    }
                                    showYearDropdown
                                    dropdownMode="select"
                                    className="certificate-files-datepicker-search"
                                    scrollableYearDropdown
                                    dateFormat="dd/MM/yyyy"
                                    locale={ka}
                                    popperProps={{
                                        positionFixed: true
                                    }}

                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                                <DatePicker
                                    selected={formData.InspectionSertificatValidityPeriodDateTo}
                                    onChange={(newValue) => handleChange('InspectionSertificatValidityPeriodDateTo', newValue)}
                                    customInput={<TextField className={"slide-in-input"}
                                                            label="ინსპექტირების სერტიფიკატის მოქმედების ვადამდე"
                                                            variant="outlined"
                                                            InputProps={{
                                                                endAdornment: formData.InspectionSertificatValidityPeriodDateTo !== null ? (
                                                                    <InputAdornment position="end">
                                                                        <IconButton
                                                                            onClick={() => {
                                                                                handleChange('InspectionSertificatValidityPeriodDateTo', null)
                                                                            }}
                                                                            edge="end"
                                                                        >
                                                                            <MdClose/>
                                                                        </IconButton>
                                                                    </InputAdornment>
                                                                ) : null,
                                                            }}/>}
                                    autoComplete="off"
                                    showMonthDropdown
                                    disabled={formData.InspectionDocumentmplementationDateFrom !== null
                                        || formData.InspectionDocumentmplementationDateTo !== null
                                        || formData.InspectionDocumentCheckingDateFrom !== null
                                        || formData.InspectionDocumentCheckingDateTo !== null
                                        || formData.InpectOrderAttachmentDateFrom !== null
                                        || formData.InpectOrderAttachmentDateTo !== null
                                    }
                                    showYearDropdown
                                    dropdownMode="select"
                                    className="certificate-files-datepicker-search"
                                    scrollableYearDropdown
                                    dateFormat="dd/MM/yyyy"
                                    locale={ka}
                                    popperProps={{
                                        positionFixed: true
                                    }}

                                />
                            </Grid>
                        </>)}
                        {(fileTypeFilter !== 'IsInspectFile' && fileTypeFilter !== 'InpectOrderAttachment') && (<>
                            <Grid item xs={12} sm={6} md={4}>
                                <DatePicker
                                    selected={formData.InspectionDocumentmplementationDateFrom}
                                    onChange={(newValue) => handleChange('InspectionDocumentmplementationDateFrom', newValue)}
                                    customInput={<TextField className={"slide-in-input"}
                                                            label="ინსპექტირების ოქმის განხორციელების თარიღიდან"
                                                            variant="outlined" InputProps={{
                                        endAdornment: formData.InspectionDocumentmplementationDateFrom !== null ? (
                                            <InputAdornment position="end">
                                                <IconButton
                                                    onClick={() => {
                                                        handleChange('InspectionDocumentmplementationDateFrom', null)
                                                    }}
                                                    edge="end"
                                                >
                                                    <MdClose/>
                                                </IconButton>
                                            </InputAdornment>
                                        ) : null,
                                    }}/>}
                                    autoComplete="off"
                                    disabled={formData.sertificatReleaseDateTo !== null ||
                                        formData.sertificatReleaseDateFrom !== null ||
                                        formData.InspectionSertificatValidityPeriodDateFrom !== null ||
                                        formData.InspectionSertificatValidityPeriodDateTo !== null ||
                                        formData.InpectOrderAttachmentDateFrom !== null ||
                                        formData.InpectOrderAttachmentDateTo !== null

                                    }
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                    scrollableYearDropdown
                                    className="certificate-files-datepicker-search"
                                    dateFormat="dd/MM/yyyy"
                                    locale={ka}
                                    popperProps={{
                                        positionFixed: true
                                    }}

                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                                <DatePicker
                                    selected={formData.InspectionDocumentmplementationDateTo}
                                    onChange={(newValue) => handleChange('InspectionDocumentmplementationDateTo', newValue)}
                                    customInput={<TextField className={"slide-in-input"}
                                                            label="ინსპექტირების ოქმის განხორციელების თარიღამდე"
                                                            variant="outlined"
                                                            InputProps={{
                                                                endAdornment: formData.InspectionDocumentmplementationDateTo !== null ? (
                                                                    <InputAdornment position="end">
                                                                        <IconButton
                                                                            onClick={() => {
                                                                                handleChange('InspectionDocumentmplementationDateTo', null)
                                                                            }}
                                                                            edge="end"
                                                                        >
                                                                            <MdClose/>
                                                                        </IconButton>
                                                                    </InputAdornment>
                                                                ) : null,
                                                            }}/>}
                                    autoComplete="off"
                                    showMonthDropdown
                                    disabled={formData.sertificatReleaseDateTo !== null ||
                                        formData.sertificatReleaseDateFrom !== null ||
                                        formData.InspectionSertificatValidityPeriodDateFrom !== null ||
                                        formData.InspectionSertificatValidityPeriodDateTo !== null ||
                                        formData.InpectOrderAttachmentDateFrom !== null ||
                                        formData.InpectOrderAttachmentDateTo !== null
                                    }
                                    showYearDropdown
                                    dropdownMode="select"
                                    className="certificate-files-datepicker-search"
                                    scrollableYearDropdown
                                    dateFormat="dd/MM/yyyy"
                                    locale={ka}
                                    popperProps={{
                                        positionFixed: true
                                    }}

                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                                <DatePicker
                                    selected={formData.InspectionDocumentCheckingDateFrom}
                                    onChange={(newValue) => handleChange('InspectionDocumentCheckingDateFrom', newValue)}
                                    customInput={<TextField className={"slide-in-input"}
                                                            label="ინსპექტირების ოქმის გადამოწმების თარიღიდან"
                                                            variant="outlined"
                                                            InputProps={{
                                                                endAdornment: formData.InspectionDocumentCheckingDateFrom !== null ? (
                                                                    <InputAdornment position="end">
                                                                        <IconButton
                                                                            onClick={() => {
                                                                                handleChange('InspectionDocumentCheckingDateFrom', null)
                                                                            }}
                                                                            edge="end"
                                                                        >
                                                                            <MdClose/>
                                                                        </IconButton>
                                                                    </InputAdornment>
                                                                ) : null,
                                                            }}/>}
                                    autoComplete="off"
                                    showMonthDropdown
                                    disabled={formData.sertificatReleaseDateTo !== null ||
                                        formData.sertificatReleaseDateFrom !== null ||
                                        formData.InspectionSertificatValidityPeriodDateFrom !== null ||
                                        formData.InspectionSertificatValidityPeriodDateTo !== null
                                        || formData.InpectOrderAttachmentDateFrom !== null
                                        || formData.InpectOrderAttachmentDateTo !== null
                                    }
                                    showYearDropdown
                                    dropdownMode="select"
                                    className="certificate-files-datepicker-search"
                                    scrollableYearDropdown
                                    dateFormat="dd/MM/yyyy"
                                    locale={ka}
                                    popperProps={{
                                        positionFixed: true
                                    }}

                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                                <DatePicker
                                    selected={formData.InspectionDocumentCheckingDateTo}
                                    onChange={(newValue) => handleChange('InspectionDocumentCheckingDateTo', newValue)}
                                    customInput={<TextField className={"slide-in-input"}
                                                            label="ინსპექტირების ოქმის გადამოწმების თარიღამდე"
                                                            variant="outlined"
                                                            InputProps={{
                                                                endAdornment: formData.InspectionDocumentCheckingDateTo !== null ? (
                                                                    <InputAdornment position="end">
                                                                        <IconButton
                                                                            onClick={() => {
                                                                                handleChange('InspectionDocumentCheckingDateTo', null)
                                                                            }}
                                                                            edge="end"
                                                                        >
                                                                            <MdClose/>
                                                                        </IconButton>
                                                                    </InputAdornment>
                                                                ) : null,
                                                            }}/>}
                                    autoComplete="off"
                                    showMonthDropdown
                                    disabled={
                                        formData.sertificatReleaseDateTo !== null ||
                                        formData.sertificatReleaseDateFrom !== null ||
                                        formData.InspectionSertificatValidityPeriodDateFrom !== null ||
                                        formData.InspectionSertificatValidityPeriodDateTo !== null
                                        || formData.InpectOrderAttachmentDateFrom !== null
                                        || formData.InpectOrderAttachmentDateTo !== null
                                    }
                                    showYearDropdown
                                    dropdownMode="select"
                                    className="certificate-files-datepicker-search"
                                    scrollableYearDropdown
                                    dateFormat="dd/MM/yyyy"
                                    locale={ka}
                                    popperProps={{
                                        positionFixed: true
                                    }}

                                />
                            </Grid>
                        </>)}
                        {(fileTypeFilter !== 'IsSertificatFile' && fileTypeFilter !== 'IsInspectFile') && (<>
                            <Grid item xs={12} sm={6} md={4}>
                                <DatePicker
                                    selected={formData.InpectOrderAttachmentDateFrom}
                                    onChange={(newValue) => handleChange('InpectOrderAttachmentDateFrom', newValue)}
                                    customInput={<TextField className={"slide-in-input"}
                                                            label="სამართალდარღვევის ოქმის შედგენის თარიღიდან"
                                                            variant="outlined" InputProps={{
                                        endAdornment: formData.InpectOrderAttachmentDateFrom !== null ? (
                                            <InputAdornment position="end">
                                                <IconButton
                                                    onClick={() => {
                                                        handleChange('InpectOrderAttachmentDateFrom', null)
                                                    }}
                                                    edge="end"
                                                >
                                                    <MdClose/>
                                                </IconButton>
                                            </InputAdornment>
                                        ) : null,
                                    }}/>}
                                    disabled={formData.InspectionDocumentmplementationDateFrom !== null
                                        || formData.InspectionDocumentmplementationDateTo !== null
                                        || formData.InspectionDocumentCheckingDateFrom !== null
                                        || formData.InspectionDocumentCheckingDateTo !== null ||
                                        formData.sertificatReleaseDateTo !== null ||
                                        formData.sertificatReleaseDateFrom !== null ||
                                        formData.InspectionSertificatValidityPeriodDateFrom !== null ||
                                        formData.InspectionSertificatValidityPeriodDateTo !== null
                                    }
                                    autoComplete="off"
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                    className="certificate-files-datepicker-search"
                                    scrollableYearDropdown
                                    dateFormat="dd/MM/yyyy"
                                    locale={ka}
                                    popperProps={{
                                        positionFixed: true
                                    }}

                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                                <DatePicker
                                    selected={formData.InpectOrderAttachmentDateTo}
                                    onChange={(newValue) => handleChange('InpectOrderAttachmentDateTo', newValue)}
                                    customInput={<TextField className={"slide-in-input"}
                                                            label="სამართალდარღვევის ოქმის შედგენის თარიღამდე"
                                                            variant="outlined" InputProps={{
                                        endAdornment: formData.InpectOrderAttachmentDateTo !== null ? (
                                            <InputAdornment position="end">
                                                <IconButton
                                                    onClick={() => {
                                                        handleChange('InpectOrderAttachmentDateTo', null)
                                                    }}
                                                    edge="end"
                                                >
                                                    <MdClose/>
                                                </IconButton>
                                            </InputAdornment>
                                        ) : null,
                                    }}/>}
                                    autoComplete="off"
                                    showMonthDropdown
                                    disabled={
                                        formData.InspectionDocumentmplementationDateFrom !== null
                                        || formData.InspectionDocumentmplementationDateTo !== null
                                        || formData.InspectionDocumentCheckingDateFrom !== null
                                        || formData.InspectionDocumentCheckingDateTo !== null ||
                                        formData.sertificatReleaseDateTo !== null ||
                                        formData.sertificatReleaseDateFrom !== null ||
                                        formData.InspectionSertificatValidityPeriodDateFrom !== null ||
                                        formData.InspectionSertificatValidityPeriodDateTo !== null

                                    }
                                    showYearDropdown
                                    dropdownMode="select"
                                    className="certificate-files-datepicker-search"
                                    scrollableYearDropdown
                                    dateFormat="dd/MM/yyyy"
                                    locale={ka}
                                    popperProps={{
                                        positionFixed: true
                                    }}

                                />
                            </Grid>


                        </>)}


                        <Grid item xs={12} sm={6} md={4}>
                            <FormControl fullWidth>
                                <InputLabel id="permit-type-label">ობიექტი</InputLabel>
                                <Select
                                    labelId="permit-type-label"
                                    value={formData.PertmiTypeIdList}
                                    label="ობიექტი"
                                    className={"slide-in-input"}
                                    variant={"outlined"}
                                    onChange={(e) => handleChange('PertmiTypeIdList', e.target.value)}
                                >
                                    {permitTypes.map((type) => (
                                        <MenuItem key={type.id} value={type.id}>{type.title}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={6} md={4}>
                            <FormControl fullWidth>
                                <InputLabel id="region-label">რეგიონი</InputLabel>
                                <Select
                                    variant={"outlined"}
                                    labelId="region-label"
                                    value={formData.RegionName}
                                    className={"slide-in-input"}
                                    label="რეგიონი"
                                    onChange={(e) => handleChange('RegionName', e.target.value)}
                                >
                                    {regions.map((region) => (
                                        <MenuItem key={region.itemName}
                                                  value={region.itemName}>{region.itemName}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                    </div>
                    <div style={{display: "flex", gap: 10}}>
                        <Button
                            onClick={fetchFiles}
                            variant="contained"
                            color="primary"
                            fullWidth
                            endIcon={<AiOutlineSearch/>}
                        >
                            ძიება
                        </Button>
                        <Button
                            onClick={clearForm}
                            variant="contained"
                            color="error"
                            fullWidth
                            endIcon={<AiOutlineClear/>}
                        >
                            ფილტრების წაშლა
                        </Button>

                        <Tooltip
                            title={selectedFiles.length === 0 ? "გადმოწერისთვის აირჩიეთ დოკუმენტები!" : ""}>
                            <span
                                style={{cursor: selectedFiles.length === 0 ? 'not-allowed' : 'pointer', width: "100%"}}>
                                <Button
                                    onClick={handleDownload}
                                    variant="contained"
                                    color="primary"
                                    fullWidth
                                    disabled={selectedFiles.length === 0 || isDownloading}
                                    endIcon={<CloudDownloadIcon/>}
                                >
                                    {isDownloading ? "გთხოვთ დაელოდოთ..." : "დოკუმენტების გადმოწერა"}
                                </Button>
                            </span>
                        </Tooltip>
                    </div>
                    <div className="certificate-files-count-box-container">
                        <div style={{marginTop: 10}} className="certificate-files-count-box">
                            <div>
                                {loading ? (
                                    <CircularProgress size={24}/>
                                ) : (
                                    <>
                                        <span style={{
                                            verticalAlign: 'middle',
                                            marginRight: 5
                                        }}>ნაპოვნია {totalCount} დოკუმენტი</span>
                                        <FaSearch size={18} style={{verticalAlign: 'middle'}}/>
                                    </>
                                )}
                            </div>
                        </div>
                        {selectedFiles.length === totalCount && totalCount !== 0 && (
                            <div style={{marginTop: 10}} className="certificate-files-count-box">
                                <div>

                                    <div style={{
                                        verticalAlign: 'middle',
                                        marginRight: 5
                                    }}>
                                        თქვენ მონიშნეთ ყველა დოკუმენტი!
                                    </div>

                                </div>
                            </div>
                        )}

                        {selectedFiles.length > 0 && (
                            <div style={{marginTop: 10}} className="certificate-files-count-box">
                                <div>

                                    <div style={{
                                        verticalAlign: 'middle',
                                        marginRight: 5
                                    }}>
                                        მონიშნულია {selectedFiles.length} დოკუმენტი
                                    </div>
                                    <FaFileAlt size={18} style={{verticalAlign: 'middle'}}/>

                                </div>

                            </div>
                        )}

                    </div>


                    {hasActiveFilters(formData) && (
                        <Grid item xs={12}>
                            <Stack
                                direction="row"
                                spacing={1}
                                flexWrap="wrap"
                                sx={{
                                    backgroundColor: '#f1f1f1',
                                    padding: '10px',
                                    borderRadius: '8px',
                                    marginTop: '10px',
                                    border: '1px solid #d0d0d0'
                                }}
                            >
                                <FilterChips filters={formData} onDelete={handleDeleteFilter}/>
                            </Stack>
                        </Grid>
                    )}
                    <div style={{marginTop: 20}}></div>

                    {loading ? (
                        <div className="nothing-found-message">
                            <CircularProgress color="primary"/>
                            <p>გთხოვთ დაელოდოთ...</p>
                        </div>
                    ) : alertMessage !== "" ? (
                        <div className="nothing-found-message">
                            <FontAwesomeIcon icon={faSearch} size="3x"/>
                            <p>{alertMessage}</p>
                        </div>
                    ) : filesList.length === 0 ? (
                        <div className="nothing-found-message">
                            <FontAwesomeIcon icon={faSearch} size="3x"/>
                            <p>არაფერი მოიძებნა!</p>
                        </div>
                    ) : (
                        <Paper sx={{width: '100%', overflow: 'hidden'}}>
                            <TableContainer>
                                <Table stickyHeader aria-label="sticky table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell padding="checkbox">
                                                <Tooltip
                                                    placement={"top"}
                                                    title={totalCount > 0 && selectedFiles.length === documentIds.length ? "გაუქმება" : "ყველას მონიშვნა"}>
                                                    <span>
                                                        <Checkbox
                                                            color="primary"
                                                            indeterminate={selectedFiles.length > 0 && selectedFiles.length < filesList.length}
                                                            checked={totalCount > 0 && selectedFiles.length === documentIds.length}
                                                            onChange={handleSelectAll}
                                                        />
                                                    </span>
                                                </Tooltip>
                                            </TableCell>
                                            <TableCell align={'center'}>განაცხადის ნომერი</TableCell>
                                            <TableCell align={'center'}>დოკუმენტის ნომერი</TableCell>
                                            <TableCell align={'center'}>რეგიონი</TableCell>
                                            <TableCell align={'center'}>ობიექტი</TableCell>
                                            <TableCell align={'center'}>გაცემის თარიღი</TableCell>
                                            <TableCell align={'center'}>მოქმედების ვადა</TableCell>
                                            <TableCell align={'center'}>განხორციელების თარიღი</TableCell>
                                            <TableCell align={'center'}>გადამოწმების თარიღი</TableCell>
                                            <TableCell align={'center'}>შედგენის თარიღი</TableCell>
                                            <TableCell align={'center'}>დოკუმენტის ტიპი</TableCell>
                                            <TableCell align={'center'}>დოკუმენტის ნახვა</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody className="certificate-files-table">
                                        {filesList.map((file) => (
                                            <TableRow
                                                key={file.caseFileId}
                                                selected={isSelected(file.caseFileId)}
                                                onClick={() => handleSelect(file.caseFileId)}
                                                role="checkbox"
                                                hover
                                                style={{cursor: 'pointer'}}
                                            >
                                                <TableCell padding="checkbox">
                                                    <Checkbox
                                                        checked={isSelected(file.caseFileId)}
                                                        inputProps={{'aria-labelledby': `enhanced-table-checkbox-${file.caseFileId}`}}
                                                    />
                                                </TableCell>

                                                <TableCell align={'center'}
                                                           onClick={(event) => {
                                                               event.stopPropagation();
                                                               window.open("/dashboard/mycases/casemanager?id=" + file.caseId.toString(), '_blank');
                                                           }}
                                                           className={"certificate-files-casenumber"}>
                                                    {file.caseNumber}
                                                </TableCell>

                                                <TableCell align={'center'}>{file.casefileNumber}</TableCell>
                                                <TableCell align={'center'}>{file.regionsNames}</TableCell>
                                                <TableCell
                                                    align={'center'}>{findObjectNameById(file.casePermitTypeId)}
                                                </TableCell>
                                                <TableCell
                                                    align={'center'}>{formatDate(file.sertificatReleaseDate)}
                                                </TableCell>
                                                <TableCell
                                                    align={'center'}>{formatDate(file.inspectionSertificatValidityPeriodDate)}
                                                </TableCell>
                                                <TableCell
                                                    align={'center'}>{formatDate(file.inspectionDocumentmplementation)}
                                                </TableCell>
                                                <TableCell
                                                    align={'center'}>{formatDate(file.inspectionDocumentCheckingDate)}
                                                </TableCell>
                                                <TableCell
                                                    align={'center'}>{formatDate(file.inpectOrderAttachmentDate)}
                                                </TableCell>
                                                <TableCell
                                                    style={{width: 200}}
                                                    align={'center'}>{file.isInspectFile ? "ინსპექტირების ოქმი" : "ინსპექტირების სერტიფიკატი"}
                                                </TableCell>
                                                <TableCell align={'center'}>
                                                    <a href={file.caseFileUrl} target="_blank"
                                                       rel="noopener noreferrer"
                                                       style={{textDecoration: 'none'}}>
                                                        <AiOutlineFile
                                                            className={"certificate-files-documenticon"}/>
                                                    </a>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                margin: '20px 0'
                            }}>
                                <Pagination
                                    count={Math.ceil(totalCount / pageSize)}
                                    page={page}
                                    onChange={(event, value) => setPage(value)}
                                    color="primary"
                                />
                                <FormControl>
                                    <InputLabel id="page-size-label">მაჩვენე</InputLabel>
                                    <Select
                                        variant={"outlined"}
                                        labelId="page-size-label"
                                        value={pageSize}
                                        style={{width: 75, marginRight: 10}}
                                        label="მაჩვენე"
                                        onChange={e => {
                                            setPageSize(e.target.value);
                                            setPage(1); // Reset to page 1 when page size changes
                                        }}
                                    >
                                        {[10, 20, 30, 40, 50, 100].map(size => (
                                            <MenuItem key={size} value={size}>{size}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </div>


                        </Paper>

                    )}
                    {showAlert && (
                        <CustomAlert
                            message={alertMessage}
                            type={alertType}
                            onClose={() => setShowAlert(false)}
                        />
                    )}
                </div>
            </Box>
        </div>
    );
};

export default CertificateFilesFetcher;
